import clsx from "clsx";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loader from "@/components/common/loader";
import { UserFields } from "@/types/cart";
import { setParam } from "~/redux/action-creaters/cart";

import styles from "./index.module.scss";
import Maper from "./maper";
import Points from "./points";
import PointsTk from "./pointsTk";

const tabs = {
  list: "list",
  map: "map",
};

export default function DeliveryMap({
  isError,
  points,
  isLoading,
  isTk = false,
}: any) {
  const [currentTab, setTab] = useState(tabs.list);
  const dispatch = useDispatch();
  const { paymentList, params } = useSelector((state: any) => state.cart);

  const pointId = useMemo(() => {
    return params[UserFields.pointId] ?? null;
  }, [params]);

  const onSelectPoint = async (id: string, price = 0, type = "ONLINE") => {
    const point = points.find((item: any) => item.ID === id);
    const payment = paymentList.find((item: any) => item.CODE === type);
    await dispatch(
      setParam({
        ...params,
        [UserFields.paySystemId]: payment.ID,
        [UserFields.deliveryDays]: point.DEL_DAYS,
        [UserFields.deliveryPrice]: price,
        [UserFields.pointInfo]:
          (point.IS_TK ? `${point.TITLE}, ` : "") + point.NAME,
        [UserFields.pointId]: id,
      }),
    );
  };

  const selectedPayment = useMemo(() => {
    return (
      paymentList?.find(
        (item: any) => item.ID === params[UserFields.paySystemId],
      ) ?? {}
    );
  }, [paymentList, params]);

  return (
    <>
      {isError && (
        <div className={clsx(styles.Error, "error")}>Выберите пункт</div>
      )}
      {isLoading && (
        <div className={styles.Loader}>
          <Loader />
        </div>
      )}
      {!isLoading && (
        <div>
          <div className={styles.Tabs}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <span
              onClick={() => {
                setTab(tabs.list);
              }}
              className={clsx(currentTab === tabs.list && styles.Selected)}
            >
              Списком
            </span>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <span
              onClick={() => {
                setTab(tabs.map);
              }}
              className={clsx(currentTab === tabs.map && styles.Selected)}
            >
              На карте
            </span>
          </div>
          <div className={styles.List}>
            {currentTab === tabs.list && (
              <div>
                {isTk ? (
                  <PointsTk
                    points={points}
                    pointId={pointId}
                    selectedPayment={selectedPayment}
                    onSelectPoint={onSelectPoint}
                  />
                ) : (
                  <Points
                    points={points}
                    pointId={pointId}
                    selectedPayment={selectedPayment}
                    onSelectPoint={onSelectPoint}
                  />
                )}
              </div>
            )}
            {currentTab === tabs.map && (
              <div>
                <Maper
                  points={points}
                  pointId={pointId}
                  selectedPayment={selectedPayment}
                  onSelectPoint={onSelectPoint}
                  isTk={isTk}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
